import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=4581f21a&scoped=true"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581f21a",
  null
  
)

export default component.exports